import { render, staticRenderFns } from "./CreateExport.vue?vue&type=template&id=5fac336c&scoped=true"
import script from "./CreateExport.vue?vue&type=script&lang=js"
export * from "./CreateExport.vue?vue&type=script&lang=js"
import style0 from "./CreateExport.vue?vue&type=style&index=0&id=5fac336c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac336c",
  null
  
)

export default component.exports